import { Link } from '@tanstack/react-router';
import { Compass } from 'lucide-react';
import { EmptyState } from '~/ui/EmptyState';

export function NotFound() {
  return (
    <main className="mx-auto max-w-[880px] px-4 py-16">
      <EmptyState
        icon={<Compass aria-hidden />}
        title="There is nothing at this address."
        body="The link may be old, or the page has moved."
        action={
          <Link to="/my-day" className="text-accent underline-offset-2 hover:underline">
            Go to My Day
          </Link>
        }
      />
    </main>
  );
}
